import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { ttt } from '@xingternal/malt-tracking';
import { XingFrameConsumer } from '@xingternal/xing-frame-provider';
import { withFlavourCSS } from '@xingternal/flavour';

import base from './Sidebar.css';
import flavours from './flavours';
import trackings from '../trackings';

const SIDEBAR_ID = '__SIDEBAR';

const Sidebar = ({ className, styles, notrack, children }) => (
  <XingFrameConsumer>
    {({ hasOpenedSidebar, toggleSidebar }) => (
      <aside className={classNames(className, styles.sidebar)}>
        <input
          id={SIDEBAR_ID}
          type="checkbox"
          value="open"
          checked={hasOpenedSidebar}
          className={styles.checkboxId}
          onChange={e => {
            !hasOpenedSidebar &&
              ttt._initCalled &&
              !notrack &&
              ttt.event('PropTrackAction', {
                PropTrackAction: trackings.burger.open.PropTrackAction,
              });
            toggleSidebar(e);
          }}
        />
        <label htmlFor={SIDEBAR_ID} className={styles.navShim} />
        <label htmlFor={SIDEBAR_ID} className={styles.navBurger}>
          <span className={styles.line} />
          <span className={styles.line} />
          <span className={styles.line} />
        </label>
        {children}
      </aside>
    )}
  </XingFrameConsumer>
);

Sidebar.displayName = 'Sidebar';

Sidebar.propTypes = {
  /** fills the content area of the frame  */
  children: PropTypes.node,
  /** provides modular css classes  */
  styles: PropTypes.object,
  /** custom styles */
  className: PropTypes.string,
  notrack: PropTypes.bool,
};

export default withFlavourCSS(base, flavours)(Sidebar);
